import "./assets/scss/main.scss";

import { createApp, markRaw } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";

import { QuillEditor } from "@vueup/vue-quill";

import { setupCalendar } from "v-calendar";

import maxLines from "./directives/maxLines";
import emTooltip from "./directives/tooltip";
import ripple from "./directives/ripple";
import loadPage from "./directives/loadPage";

import echo from "./echo.js";

import * as Sentry from "@sentry/vue";

const app = createApp(App);

// Laravel Echo (Websocket)
app.config.globalProperties.$echo = echo;
window.Echo = echo;

// Sentry Setup
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    // Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/exploremeds\.scrumad\.com/, /^https:\/\/exploremeds\.scrumad\.com\/api/],
  // Session Replay
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Console Logs to Sentry
// const captureStructuredLog = (level, args) => {
//   const logData = {
//     level,
//     message: args.map(arg => (typeof arg === 'object' ? JSON.stringify(arg) : arg)).join(' '),
//     timestamp: new Date().toISOString(),
//     extra: {},
//   };
//
//   // If the first argument is an object, consider it as structured data
//   if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
//     logData.extra = args[0];
//     logData.message = args.slice(1).map(arg => (typeof arg === 'object' ? JSON.stringify(arg) : arg)).join(' ');
//   }
//
//   // Capture in Sentry with structured metadata
//   Sentry.captureMessage(logData.message, {
//     level: logData.level,
//     extra: logData.extra,
//     timestamp: logData.timestamp,
//   });
// };

// const originalConsoleLog = console.log;
// const originalConsoleWarn = console.warn;
// const originalConsoleError = console.error;
//
// console.log = function (...args) {
//   captureStructuredLog('info', args);
//   originalConsoleLog.apply(console, args);
// };
// console.warn = function (...args) {
//   captureStructuredLog('warning', args);
//   originalConsoleWarn.apply(console, args);
// };
// console.error = function (...args) {
//   captureStructuredLog('error', args);
//   originalConsoleError.apply(console, args);
// };

// Sentry.setUser({
//   id: user?.id || 'guest',
// });
Sentry.setTag('environment', import.meta.env.VITE_APP_ENV);


const pinia = createPinia();

pinia.use(({ store }) => {
  store.$router = markRaw(router);
});

app.use(pinia);

app.use(router);
app.use(setupCalendar, {});

app.component("QuillEditor", QuillEditor);

app.directive("maxLines", maxLines);
app.directive("tooltip", emTooltip);
app.directive("ripple", ripple);
app.directive("loadPage", loadPage);

app.mount("#app");

window.addEventListener("click", (e) => {
  let target = e.target;
  if (document.querySelector(".fade-back") && !target.closest(".searchContainer")) {
    const searchContainer = document.querySelector(".searchContainer");
    const searchPlaceholder = document.querySelector(".searchPlaceholder");
    searchContainer?.classList.remove("position-relative");
    searchContainer?.classList.add("hidden");
    searchContainer?.children[0]?.classList.remove("hasResults");
    searchContainer?.children[1]?.children[0]?.classList.add("d-none");
    searchPlaceholder?.classList.remove("hidden");
    document.body.classList.remove("fade-back");
  }
});

document.addEventListener("touchstart", function () {}, true);